import { useMemo } from "react";
import { useQuery } from "@apollo/client";
import { getAIDashboards } from "../queries/ai.graphql";
import { useWorkspaceFeatureFlags } from "../contexts/global/WorkspaceContext";

/**
 * Hook to extract all AI-created dashboards from chat history
 * @returns {Object} { dashboards: Array, loading: boolean, error: Error, selectedDashboardId: string }
 */
const useAIDashboards = () => {
  const { enableAIDashboards } = useWorkspaceFeatureFlags();

  // First, get all chat IDs
  const {
    data: dashboardsData,
    loading,
    error,
  } = useQuery(getAIDashboards, {
    fetchPolicy: "cache-and-network",
    skip: !enableAIDashboards,
  });

  const dashboards = useMemo(() => {
    if (!dashboardsData?.dashboards?.length) {
      return [];
    }

    // Convert map to array and sort by creation date (most recent first)
    return dashboardsData.dashboards
      .map((dashboard) => ({
        ...dashboard,
        createdAt: new Date(parseInt(dashboard.createdAt, 10)),
        updatedAt: new Date(parseInt(dashboard.updatedAt, 10)),
      }))
      .sort((a, b) => b.createdAt - a.createdAt)
      .map(({ messageIndex, ...dashboard }) => dashboard); // Remove internal fields from final output
  }, [dashboardsData]);

  return {
    dashboards,
    loading,
    error,
  };
};

export default useAIDashboards;
